import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Container, Button } from '@mui/material';
import { ArrowLeft } from '@phosphor-icons/react';
import CRMAnalytics from './CRMAnalytics';

const CRMAnalyticsPage = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="lg" sx={{ py: 3 }}>
      <Box sx={{ mb: 3 }}>
        <Button
          startIcon={<ArrowLeft size={20} />}
          onClick={() => navigate('/supplier/crm')}
          sx={{ mb: 2 }}
        >
          Back to My Couples
        </Button>
      </Box>
      <CRMAnalytics />
    </Container>
  );
};

export default CRMAnalyticsPage;
